export const PRODUCT = 'L'
